export const JSON_FILE_NAME = 'web_version_by_plugin'

export const INJECT_STYLE_FILE_NAME = 'webUpdateNoticeInjectStyle'

export const INJECT_SCRIPT_FILE_NAME = 'webUpdateNoticeInjectScript'

export const CUSTOM_UPDATE_EVENT_NAME = 'system_update_plugin_web_update_notification'

export const NOTIFICATION_ANCHOR_CLASS_NAME = 'plugin-web-update-notice-anchor'
